import Vue from 'vue'
import {VueMaskFilter} from 'v-mask'
import {numberMask} from '@/helpers/utils'

Vue.filter('VMaskMoney', function (value) {
  return VueMaskFilter(value, numberMask)
})
